"use strict";
// Names and Identifiers
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInChI = void 0;
const jsonpath_1 = __importDefault(require("jsonpath"));
function getInChI(data) {
    return {
        value: jsonpath_1.default.query(data, '$.Section[?(@.TOCHeading==="Names and Identifiers")]' +
            '.Section[?(@.TOCHeading==="Computed Descriptors")]' +
            '.Section[?(@.TOCHeading==="InChI")]' +
            '.Information[0]')[0].Value.StringWithMarkup[0].String,
        label: 'InChI',
        description: jsonpath_1.default.query(data, '$.Section[?(@.TOCHeading==="Names and Identifiers")]' +
            '.Section[?(@.TOCHeading==="Computed Descriptors")]' +
            '.Section[?(@.TOCHeading==="InChI")]')[0].Description,
    };
}
exports.getInChI = getInChI;
//# sourceMappingURL=getInChI.js.map